import React from "react";
import { makeStyles } from "tss-react/mui";
const useClasses = makeStyles()((theme) => ({
  layoutDetailsBlockContainer: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.custom.defaultBorderRadius * 3,
    padding: theme.spacing(0, 4)
  }
}));
function LayoutDetailsBlockContainer({ children }) {
  const { classes } = useClasses();
  return /* @__PURE__ */ React.createElement("div", { className: classes.layoutDetailsBlockContainer }, children);
}
export {
  LayoutDetailsBlockContainer
};
//# sourceMappingURL=LayoutDetailsBlockContainer.js.map
